import { Communication } from '@/models/Communication';
import { Actualite } from '@/models/Actualite';
import { Dashboard } from '@/models/Dashboard';
import { ParametrageWidget } from '@/models/ParametrageWidget';
import translations from '@/locales/fr.json';
import { SatisfactionDTO } from '@/models/Satisfaction';

export interface Traduction {
    nom: string;
    libelle: string;
}

export interface Langue {
    id: number;
    langue: string;
    locale: string;
}

export interface HomeState {
    communication: Communication | null;
    actualites?: Actualite[];
    nbNouvellesActus?: 0;
    actualiteOpen?: false;
    actualiteLoading: boolean;
    registerMailLoading: boolean;
    nbNouvellesReclamation: number;
    languesDisponibles: Langue[];
    langueSelectionnee?: Langue;
    traductions: Traduction[];
    modalChoixPortailOuverte: boolean;
    dashboards: Dashboard[];
    selectedDashboard?: Dashboard;
    createdDashboard?: Dashboard;
    widgets: ParametrageWidget[];
    enregistementDashboardEnCours: boolean;
    openModaleWidget: boolean;
    dasboardLoading: boolean;
    satisfactionConditions?: SatisfactionDTO;
}

export const state: HomeState = {
    communication: null,
    actualiteLoading: true,
    registerMailLoading: false,
    nbNouvellesReclamation: 0,
    traductions: translations,
    languesDisponibles: [],
    modalChoixPortailOuverte: false,
    dashboards: [],
    widgets: [],
    enregistementDashboardEnCours: false,
    openModaleWidget: false,
    dasboardLoading: false,
};
